<div>
  <h1>Logs</h1>
</div>

<app-logs-list [highlight]="highlight" [likeSearch]="likeSearch" [dateStart]="dateStart" [dateEnd]="dateEnd"
               [zombieId]="zombieId" [limit]="limit"
               (filter)="updateUrl($event)"></app-logs-list>
